import { render, staticRenderFns } from "./MarkedAppeal.vue?vue&type=template&id=5866c8fb&scoped=true&lang=pug"
import script from "./MarkedAppeal.vue?vue&type=script&lang=js"
export * from "./MarkedAppeal.vue?vue&type=script&lang=js"
import style0 from "./MarkedAppeal.vue?vue&type=style&index=0&id=5866c8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5866c8fb",
  null
  
)

export default component.exports